import { UserProfile } from '../../types';

// Define the props this component now accepts
interface AdminPanelProps {
  activeView: string;
  onViewChange: (view: string) => void;
}

// The AdminPanel is now just a sidebar navigation component
export function AdminPanel({ activeView, onViewChange }: AdminPanelProps) {
  return (
    <nav className='admin-sidebar'>
      <ul>
        <li>
          <button
            onClick={() => onViewChange('fileManager')}
            className={`sidebar-button ${
              activeView === 'fileManager' ? 'active' : ''
            }`}
          >
            File Manager
          </button>
        </li>
        <li>
          <button
            onClick={() => onViewChange('manageUsers')}
            className={`sidebar-button ${
              activeView === 'manageUsers' ? 'active' : ''
            }`}
          >
            Manage Users
          </button>
        </li>
        <li>
          <button
            onClick={() => onViewChange('createNewUser')}
            className={`sidebar-button ${
              activeView === 'createNewUser' ? 'active' : ''
            }`}
          >
            Create New User
          </button>
        </li>
        <li>
          <button
            onClick={() => onViewChange('manageCompanies')}
            className={`sidebar-button ${
              activeView === 'manageCompanies' ? 'active' : ''
            }`}
          >
            Manage Companies
          </button>
        </li>
      </ul>
    </nav>
  );
}
